var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgReplyOriginal(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.578 11.3436L4.74365 2.47487C4.61028 2.40118 4.45762 2.36987 4.306 2.38511C4.15439 2.40034 4.01101 2.46139 3.89495 2.56014C3.7789 2.65889 3.69568 2.79064 3.65637 2.93786C3.61706 3.08508 3.62352 3.24079 3.6749 3.38424L6.65615 11.7467C6.72183 11.9091 6.72183 12.0906 6.65615 12.253L3.6749 20.6155C3.62352 20.7589 3.61706 20.9146 3.65637 21.0619C3.69568 21.2091 3.7789 21.3408 3.89495 21.4396C4.01101 21.5383 4.15439 21.5994 4.306 21.6146C4.45762 21.6299 4.61028 21.5986 4.74365 21.5249L20.578 12.6561C20.6953 12.5913 20.793 12.4962 20.861 12.3808C20.9291 12.2654 20.9649 12.1338 20.9649 11.9999C20.9649 11.8659 20.9291 11.7344 20.861 11.619C20.793 11.5036 20.6953 11.4085 20.578 11.3436V11.3436Z",
    stroke: "#8E8E8E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.75 12H12.75",
    stroke: "#8E8E8E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReplyOriginal);
export default __webpack_public_path__ + "static/media/reply_original.dbe04dcf835f2683200e2f8fb6f16c14.svg";
export { ForwardRef as ReactComponent };